import { Form, Input } from "ant-design-vue";
import { WrappedFormUtils, FieldDecoratorOptions } from "ant-design-vue/lib";
import "ant-design-vue/dist/antd.less";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { VersionGroupModel } from "@/services";
import { CommonLocale, LessonPlanLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
import LessonPlanVersionState from "@/modules/lesson-plan-version";
import { ILessonPlanVersionModel, LessonPlanVersionColumns } from "@/models/lesson-plan";
import VersionGroupSelect from "@/components/version-group-select/version-group-select.vue";
import MethodologySelect from "@/components/methodology-select/methodology-select.vue";
import { spaceValidator } from "@/util/func";
import { LessonPlanVersionActionStatus } from "@/util/enum";

@Component({
	components: {
		"a-form": Form,
		"a-form-item": Form.Item,
		"a-input": Input,
		"a-textarea": Input.TextArea,
		VersionGroupSelect,
		MethodologySelect
	}
})
export default class DetailContent extends Vue {
	@Prop() lessonPlanVersionDetail!: ILessonPlanVersionModel;
	@Prop() disableMethodology!: boolean;
	@Prop() disableVersionGroup!: boolean;
	@Prop() versionGroups!: VersionGroupModel[];
	@Prop() currentVersionGroup!: VersionGroupModel;
	@Prop() currentAction!: LessonPlanVersionActionStatus;
	@Prop() toggleSave!: Function;
	detailForm: WrappedFormUtils;
	enableSaveButton: boolean = false;
	private lessonPlanVersionModule = getModule(LessonPlanVersionState);

	created(): void {
		this.detailForm = this.$form.createForm(this, { name: "detailForm" });
	}

	public lessonPlanVersionActionStatus = LessonPlanVersionActionStatus;

	get commonLocale(): any {
		return CommonLocale;
	}

	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}

	get versionGroupDecorator(): [string, FieldDecoratorOptions] {
		return [
			LessonPlanVersionColumns.VersionGroupIdColumn,
			{
				initialValue: this.lessonPlanVersionDetail.versionGroupId
			}
		];
	}

	get methodologyDecorator(): [string, FieldDecoratorOptions] {
		return [
			LessonPlanVersionColumns.MethodologyColumn,
			{
				initialValue: this.lessonPlanVersionDetail.methodology
			}
		];
	}

	get nameDecorator(): [string, FieldDecoratorOptions] {
		return [
			LessonPlanVersionColumns.VersionNameColumn,
			{
				initialValue: this.lessonPlanVersionDetail.name,
				rules: [
					{
						required: true,
						message: fmtMsg(LessonPlanLocale.LessonPlanVersionNameRequireMessage),
						trigger: "change"
					},
					{
						max: 100,
						message: fmtMsg(LessonPlanLocale.LessonPlanVersionNameOverflowMessage),
						trigger: "change"
					},
					{
						validator: (rule, value, callback) => {
							return spaceValidator(
								this.detailForm,
								LessonPlanVersionColumns.VersionNameColumn,
								fmtMsg(LessonPlanLocale.LessonPlanVersionNameRequireMessage),
								rule,
								value,
								callback
							);
						}
					}
				]
			}
		];
	}

	get descriptionDecorator(): [string, FieldDecoratorOptions] {
		return [
			LessonPlanVersionColumns.DescriptionColumn,
			{
				initialValue: this.lessonPlanVersionDetail.description,
				rules: [
					{
						max: 250,
						message: fmtMsg(LessonPlanLocale.LessonPlanVersionDescriptionOverflowMessage),
						trigger: "change"
					}
				]
			}
		];
	}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	onVersionGroupChanged(value: VersionGroupModel): void {
		this.lessonPlanVersionModule.setVersionGroup(value);
	}

	onResetFormFieldsValue(): void {
		this.detailForm.resetFields();
	}

	onSubmitDetailForm(success: (values: any) => void, error: (errors: any, values: any) => void): void {
		this.detailForm.validateFields((errors, values) => {
			if (errors) {
				error(errors, values);
			} else {
				success(values);
			}
		});
	}

	onLessonPlanVersionUpdate() {
		this.toggleSave(true);
	}
}
